module.exports = __webpack_public_path__ + "img/img27.fe9ee65d.png";